import { TypeConversationData } from "./type-conversation-data";
import { StatusConversationData } from "./status-conversation-data";
var ConversationData = /** @class */ (function () {
    function ConversationData() {
        this.type = TypeConversationData.PUBLIC;
        this.status = StatusConversationData.OPEN;
        this.requesters = [];
        this.messages = [];
        this.read = false;
    }
    return ConversationData;
}());
export { ConversationData };
//# sourceMappingURL=conversation-data.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-dto/message/conversation-data.js
// module id = 991
// module chunks = 14